import { render, staticRenderFns } from "./InvoicePayoffOtherList.vue?vue&type=template&id=64b91dd2&scoped=true"
import script from "./InvoicePayoffOtherList.vue?vue&type=script&lang=js"
export * from "./InvoicePayoffOtherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b91dd2",
  null
  
)

export default component.exports